export const suggestedBanners = [
  "https://minio-api.apps.konnectbd.com/konnect/C%2010.png-ZTpZr",
  "https://minio-api.apps.konnectbd.com/konnect/C%2011.png-LLvpg",
  "https://minio-api.apps.konnectbd.com/konnect/C%2012.png-HlZEK",
  "https://minio-api.apps.konnectbd.com/konnect/C%2013.png-ViUQE",
  "https://minio-api.apps.konnectbd.com/konnect/C%2014.png-ZdXLg",
  "https://minio-api.apps.konnectbd.com/konnect/C%2015.png-ugApu",
  "https://minio-api.apps.konnectbd.com/konnect/C%2016.png-JmVfB",
  "https://minio-api.apps.konnectbd.com/konnect/C%2017.png-TUuQt",
  "https://minio-api.apps.konnectbd.com/konnect/C%2018.png-eSpIV",
  "https://minio-api.apps.konnectbd.com/konnect/C%2019.png-rrNMg",
  "https://minio-api.apps.konnectbd.com/konnect/C%201.png-uQkZn",
  "https://minio-api.apps.konnectbd.com/konnect/C%202.png-WeTlo",
  "https://minio-api.apps.konnectbd.com/konnect/C%203.png-iVjQa",
  "https://minio-api.apps.konnectbd.com/konnect/C%204.png-TJZwh",
  "https://minio-api.apps.konnectbd.com/konnect/C%205.png-HMZoA",
  "https://minio-api.apps.konnectbd.com/konnect/C%206.png-lXvNE",
  "https://minio-api.apps.konnectbd.com/konnect/C%207.png-nIRZG",
  "https://minio-api.apps.konnectbd.com/konnect/C%208.png-CNGFU",
  "https://minio-api.apps.konnectbd.com/konnect/C%209.png-Ehngt",
  "https://minio-api.apps.konnectbd.com/konnect/K01.jpg-zMCIJ",
  "https://minio-api.apps.konnectbd.com/konnect/K02.jpg-uYtDU",
  "https://minio-api.apps.konnectbd.com/konnect/K03.jpg-ITGFo",
  "https://minio-api.apps.konnectbd.com/konnect/K04.jpg-svgGF",
  "https://minio-api.apps.konnectbd.com/konnect/K05.jpg-XBKPE",
  "https://minio-api.apps.konnectbd.com/konnect/K07.jpg-BiHeN",
  "https://minio-api.apps.konnectbd.com/konnect/K09.jpg-SpIIw",
  "https://minio-api.apps.konnectbd.com/konnect/K10.jpg-fZVtX",
  "https://minio-api.apps.konnectbd.com/konnect/K11.jpg-iytXI",
  "https://minio-api.apps.konnectbd.com/konnect/K12.jpg-QONsA",
  "https://minio-api.apps.konnectbd.com/konnect/K13.jpg-XFpjM",
  "https://minio-api.apps.konnectbd.com/konnect/K14.jpg-MnQen",
  "https://minio-api.apps.konnectbd.com/konnect/K15.jpg-aqCRS",
  "https://minio-api.apps.konnectbd.com/konnect/K16.jpg-JoBxO",
  "https://minio-api.apps.konnectbd.com/konnect/K17.jpg-msyOV",
  "https://minio-api.apps.konnectbd.com/konnect/K18.jpg-uGHDL",
  "https://minio-api.apps.konnectbd.com/konnect/K19.jpg-PLiBR",
  "https://minio-api.apps.konnectbd.com/konnect/K20.jpg-taohQ",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2069.png-POMjb",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2070.png-bUsaA",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2071.png-SdVOw",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2072.png-LkNsa",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2073.png-KFKEf",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2074.png-Psgql",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2075.png-sEmct",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2076.png-NYEqE",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2077.png-JtXNW",
  "https://minio-api.apps.konnectbd.com/konnect/Mask%20Group%2078.png-WdBDo",
];
export const suggestedStoreBanners = [
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686612819-413.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686671529-1182.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686720672-1713.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686892243-41719.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686933651-44593.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686854805-273848.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688699509-b9hww-579.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686778630-2148216036.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688700385-dee4ip-647.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763686821328-2148216102.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688293303-mfr8l-37894.jpg",
  "https://minio-api.apps.konnectbd.com/konnect/images/1763686411109-2149483177.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688079528-hnyv2d-2546.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688081559-b6slne-2554.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688082672-wzyeuh-3325.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688698427-ylut3j-5669.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688701219-d6yr2-85960.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688170530-plz3c5-3576.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688290293-mvprlf-66187.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688292527-0s7oou-36949.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688294278-gur9c4-39354.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688696353-i1tif7h-41713.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688168752-pr0r6a-560%20%281%29.jpg",
  "http://minio-api.apps.konnectbd.com/konnect/images/1763688171586-m1z1r-36936%20%281%29.jpg",
];
